<template>
  <transition name="slide">
    <div v-if="visible" class="sidebar-overlay" @click.self="onOverlayClick">
      <div :class="['sidebar', sizeClass]">
        <!-- Header con título -->
        <div class="sidebar-header">
          <h3 class="sidebar-title custom-white">{{ $t(title) | capitalize }}</h3>
          <slot name="header-extra"></slot>
        </div>

        <!-- Slot para contenido principal -->
        <div class="sidebar-body">
          <slot name="body"></slot>
        </div>

        <!-- Slot para footer -->
        <div class="sidebar-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BaseSidebar",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "sm",
      validator: val => ["sm", "md", "lg"].includes(val)
    }
  },
  computed: {
    sizeClass() {
      return `sidebar-size-${this.size}`;
    }
  },
  methods: {
    onOverlayClick() {
      // aquí decides si quieres cerrar o no
      // por ejemplo, con una prop que controle el comportamiento
      if (this.closeOnOverlay) {
        this.$emit("update:visible", false);
      }
    },
  }
};
</script>

<style scoped>
.sidebar-size-sm {
  min-width: 40%;
}

.sidebar-size-md {
  min-width: 60%;
}

.sidebar-size-lg {
  min-width: 80%;
}

.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: flex-end;
  z-index: 999998;
}

/* Panel */
.sidebar {
  background: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Header */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;
  background-color: #626262;
}

.sidebar-title {
  margin: 0;
  font-size: 20px;
}

/* Body */
.sidebar-body {
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
}

/* Footer */
.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid #eee;
  display: flex;
  /* activa flexbox */
  justify-content: flex-end;
  /* alinea contenido a la derecha */
  gap: 0.5rem;
  /* opcional: espacio entre botones */
}


/* Animación solo para el panel */
.slide-enter-active .sidebar,
.slide-leave-active .sidebar {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-enter .sidebar,
.slide-leave-to .sidebar {
  transform: translateX(100%);
  opacity: 0;
}

/* Overlay instantáneo: sin transición */
.slide-enter-active .sidebar-overlay,
.slide-leave-active .sidebar-overlay {
  transition: none;
}

/* Bloquear scroll de la ventana mientras el overlay exista */
:global(body:has(.sidebar-overlay)) {
  overflow: hidden;
}
</style>